import { PostData } from '../types';
export const DirectAndEmailReminder = (data: PostData) =>
  data.hasDirectPublishProfile &&
  data.hasProfileWithoutDirectPublish &&
  data.publishingMethod === 'DIRECT' &&
  !data.hasMobile;
